/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Reprocess_UpdatingInputs */

const en_ui_reprocess_updating = /** @type {(inputs: Ui_Reprocess_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrating your sessions…`)
};

const de_ui_reprocess_updating = /** @type {(inputs: Ui_Reprocess_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten werden migriert…`)
};

/**
* | output |
* | --- |
* | "Migrating your sessions…" |
*
* @param {Ui_Reprocess_UpdatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_reprocess_updating = /** @type {((inputs?: Ui_Reprocess_UpdatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Reprocess_UpdatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_reprocess_updating(inputs)
	return de_ui_reprocess_updating(inputs)
});